import { columns } from './properties/columns'
import { filter } from './properties/filter'
import { pagination } from "../properties/pagination";
import { sort } from "../properties/sort";
import { rules } from "./properties/rules";
import { model } from "./properties/model";

export const state = {
    list: [],
    model: JSON.parse(JSON.stringify(model)),
    columns: columns,
    reports: [],
    bonus: [],
    hospital_bonus: [],
    secondary_bonus: [],
    filter: filter,
    pagination: JSON.parse(JSON.stringify(pagination)),
    show_pagination: JSON.parse(JSON.stringify(pagination)),
    sort: JSON.parse(JSON.stringify(sort)),
    rules: rules,
    permissions: [],
    spess: [],
};
